var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 25C48 37.7025 37.7025 48 25 48V25V2C37.7025 2 48 12.2975 48 25ZM2 25C2 21.9796 2.59491 18.9888 3.75077 16.1983C4.90663 13.4078 6.6008 10.8723 8.73655 8.73655C10.8723 6.6008 13.4078 4.90663 16.1983 3.75077C18.9888 2.59491 21.9796 2 25 2C12.2975 2 2 12.2975 2 25ZM8.69344 41.2202C4.5566 37.0615 2 31.3293 2 25C2 28.0204 2.59491 31.0112 3.75077 33.8017C4.89884 36.5734 6.578 39.0935 8.69344 41.2202ZM8.69344 41.2202C8.72214 41.2491 8.75091 41.2779 8.77976 41.3066C8.76534 41.2922 8.75093 41.2778 8.73655 41.2635C8.72216 41.2491 8.70779 41.2347 8.69344 41.2202ZM8.77976 41.3066C10.9065 43.422 13.4266 45.1012 16.1983 46.2492C18.9888 47.4051 21.9796 48 25 48C18.6707 48 12.9385 45.4434 8.77976 41.3066ZM50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.8e3a124b.svg";
export { ForwardRef as ReactComponent };